import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { userManager } from './auth/CognitoAuth';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

/**
 * Handle the OIDC redirect/popup callback from Cognito.
 *
 * The app does not use a client-side router, so the /auth/callback path is
 * handled here, before rendering the app:
 * - Popup flow: notify the opener window and close the popup.
 * - Redirect flow (popup-blocked fallback): complete sign-in, then return
 *   to the app root.
 */
const handleAuthCallback = async (): Promise<void> => {
  root.render(
    <div style={{ padding: '2rem', textAlign: 'center', color: '#9ca3af' }}>
      Signing in...
    </div>
  );

  if (!userManager) {
    console.error('Auth callback received but Cognito is not configured');
    window.location.replace('/');
    return;
  }

  try {
    if (window.opener) {
      // Popup flow — hands the response to the opener, which resolves signinPopup()
      await userManager.signinPopupCallback();
    } else {
      // Full-page redirect flow
      await userManager.signinCallback();
      window.location.replace('/');
    }
  } catch (error) {
    console.error('❌ Auth callback failed:', error);
    window.location.replace('/');
  }
};

if (window.location.pathname === '/auth/callback') {
  handleAuthCallback();
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
